import { Component, OnDestroy } from "@angular/core";
import "./splash-screen.component.scss";

@Component({
    selector: "splash-screen",
    template: require("./splash-screen.component.html")
})
export class SplashScreenComponent implements OnDestroy {

    timeoutHandle: number;

    constructor() {
        this.timeoutHandle = setTimeout(() => this.refreshPage(), 15_000) as any;
    }

    ngOnDestroy() {
        clearTimeout(this.timeoutHandle);
    }

    // ---

    refreshPage() {
        window.location.reload();
    }
}
